export const pregnancyNudge = {
  title: 'Pregnant for the first time?',
  banner:
    'https://images.myloapp.in/NestJsUploads/1695796114635-pregnant_article_image.webp',
  list: [
    "Track baby's growth weekly",
    'Join the Mylo community',
    'Get daily pregnancy tips',
  ],
  color: '#f4fbf7',
  stripColor: '#d3eddf',
  marqueeData: [
    {
      marqueeList: [
        { text: 'Pregnant for the first time?', textColor: '#6e6e6e' },
        { text: "Track baby's growth weekly", textColor: '#6e6e6e' },
        { text: 'Join the Mylo community', textColor: '#6e6e6e' },
        { text: 'Get daily pregnancy tips', textColor: '#6e6e6e' },
      ],
      sectionBgColorStart: 'transparent',
    },
  ],
  ctaText: 'Get Mylo App',
  bannerData: {
    title: 'Week by week baby growth on the app!',
  },
};
export const motherNudge = {
  title: 'Want to raise a happy & healthy Baby?',
  banner:
    'https://images.myloapp.in/NestJsUploads/1695796114634-mother_article_image.webp',
  list: [
    "Get baby's growth & weight tips",
    'Join the Mylo Moms community',
    'Get baby diet chart',
  ],
  color: '#fdfbf2',
  stripColor: '#f8f3dc',
  marqueeData: [
    {
      marqueeList: [
        { text: 'Raise A Happy & Healthy Baby', textColor: '#6e6e6e' },
        {
          text: "Get baby's growth & weight tips",
          textColor: '#6e6e6e',
        },
        { text: 'Join the Mylo Moms community', textColor: '#6e6e6e' },
        { text: 'Get baby diet chart', textColor: '#6e6e6e' },
      ],
      sectionBgColorStart: 'transparent',
    },
  ],
  ctaText: 'Get Mylo App',
  bannerData: {
    title: "Get baby's diet chart, and growth tips",
  },
};

export const ttcNudge = {
  title: 'Trying to conceive?',
  banner:
    'https://images.myloapp.in/NestJsUploads/1695796114631-ttc_article_image.webp',
  list: [
    'Track your ovulation',
    'Join the Mylo TTC community',
    'Get daily conception tips',
  ],
  color: '#f4fbf7',
  stripColor: '#d3eddf',
  marqueeData: [
    {
      marqueeList: [
        { text: 'Trying To Conceive?', textColor: '#6e6e6e' },
        { text: 'Track your ovulation', textColor: '#6e6e6e' },
        { text: 'Join the Mylo TTC community', textColor: '#6e6e6e' },
        { text: 'Get daily conception tips', textColor: '#6e6e6e' },
      ],
      sectionBgColorStart: 'transparent',
    },
  ],
  ctaText: 'Get Mylo App',
  bannerData: {
    title: 'Track your ovulation & conceive faster',
  },
};
export const babynamesNudge = {
  title: 'Find the perfect name for your little one',
  banner:
    'https://images.myloapp.in/NestJsUploads/1695796114636-baby_names_image.webp',
  list: [
    'Looking for a beautiful name for your baby? Let us help you out! Choose from over 1 lakh names on the Mylo App.',
  ],
  color: '#fef7f7',
  stripColor: '#fef0f0',
  marqueeData: [
    {
      marqueeList: [
        {
          text: 'Perfect Name For Your Little One',
          textColor: '#6e6e6e',
        },
        { text: 'Let us help you out!', textColor: '#6e6e6e' },
        { text: 'Choose from over 1 lakh names', textColor: '#6e6e6e' },
      ],
      sectionBgColorStart: 'transparent',
    },
  ],
  ctaText: 'Get Mylo App',
};
